import {AxiosError} from 'axios';
import {useMutation, UseMutationOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';

import {useFetchGroup} from './useGroupQuery';

export const useLeaveGroupMutation = (groupID: string | number, options?: UseMutationOptions<unknown, AxiosError>) => {
  const fetchGroup = useFetchGroup(groupID);

  return useMutation<true, AxiosError>(() => api.post(`v2/groups/${groupID}/leave`), {
    ...options,
    onSuccess: (...params) => {
      options?.onSuccess?.(...params);
      fetchGroup();
    },
  });
};
